import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { useCurrency } from '@/lib/currency';

const FLAG = { EUR: '🇪🇺', USD: '🇺🇸', GBP: '🇬🇧', CHF: '🇨🇭', AED: '🇦🇪' };

export default function CurrencyDropdown({ textColor = '#171517' }) {
  const { currency, setCurrency, supported } = useCurrency();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        data-testid="currency-dropdown-trigger"
        className="flex items-center gap-1 text-[11px] uppercase tracking-wider font-medium nav-link"
        style={{ color: textColor }}
      >
        <span>{currency}</span>
        <ChevronDown size={12} />
      </button>
      {open && (
        <div
          className="absolute top-full right-0 mt-3 bg-white border border-[#E5E5E5] shadow-lg min-w-[140px] z-50"
          data-testid="currency-dropdown-menu"
        >
          {supported.map((c) => (
            <button
              key={c}
              onClick={() => { setCurrency(c); setOpen(false); }}
              data-testid={`currency-option-${c}`}
              className={`w-full flex items-center gap-3 px-4 py-2.5 text-xs uppercase tracking-wider hover:bg-[#FAF7F2] transition-colors ${c === currency ? 'text-[#C9A961] bg-[#FAF7F2]' : 'text-[#0F3530]'}`}
            >
              <span className="text-base leading-none">{FLAG[c] || ''}</span>
              <span>{c}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
